import portalRequest from '@/utils/request';
import request from '@/utils/seftRequest';

// 登陆前校验是不是staff用户
export function preLogin(params) {
  return portalRequest('/drm/selfserv/preLogin', {
    method: 'POST',
    body: params,
  });
}

// 登陆根据useCode发送短信验证码
export function sendVerifyCode(params) {
  return request('/ding/genCaptcha', {
    method: 'POST',
    body: params,
  });
}

// 获取是否只能打开一个页面tabs
export function qryAllowMultipleTabPage() {
  return portalRequest('/prod/sysparams/qryAllowMultipleTabPage');
}

// 图形验证码生成接口
export function genCaptcha() {
  return request('/ding/genCaptcha', {
    method: 'POST',
  });
}

// 忘记密码
export function doForgetPwdBsnl(params) {
  return request('/ding/login/doForgetPwdBsnl', {
    method: 'POST',
    body: params,
  });
}

// 忘记密码useCode发送短信验证码
export function sendSmsForgetPwdBsnl(params) {
  return request('/ding/login/sendSmsForgetPwdBsnl', {
    method: 'POST',
    body: params,
  });
}
